<template>
  <div class="item" :class="{ selected: checked }" @click="handleChange">
    <span class="item__label">
      <component class="icon" :is="option.icon" />

      <div>
        <h4>{{ option.title }}</h4>
        <p>{{ option.description }}</p>
      </div>
    </span>

    <a-radio :checked="checked" :value="component.vnode.key" @change="handleChange" />
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance } from "vue";
export default defineComponent({
  props: {
    value: {
      required: true,
      type: Number,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const component = getCurrentInstance();
    return {
      component,
    };
  },
  computed: {
    checked() {
      return this.value === this.component.vnode.key;
    },
  },
  methods: {
    handleChange() {
      this.$emit("update:value", this.component.vnode.key);
    },
  },
});
</script>

<style lang="sass" scoped>
.item
  height: 85px
  padding: 12px 20px
  border-radius: 8px
  border: 1px solid $gray-5
  display: flex
  align-items: center
  justify-content: space-between
  gap: 18px
  cursor: pointer

  &:hover
    border: 1px solid $blue-5
    box-shadow: 0px 0px 4px 0px rgba(24, 144, 255, 0.50)

  &.selected
    border-color: $blue-5

  &__label
    font-size: $font-small
    color: $gray-8
    display: flex
    // align-item: center
    gap: 12px

    & *
      margin: 0
      line-height: 20px

    .icon
      font-size: 20px
      flex: 0 0 20px
      color: #003A8C

    h4
      font-weight: 600
</style>
